export const STORAGE_KEYS = {
  TOKEN: 'maze-navigation:token',
  TUTORIAL_GUIDE_COMPLETED: 'maze-navigation:tutorial-guide-completed',
} as const;
